"use strict";
// @ts-ignore
try {
    self['workbox:recipes:6.2.4'] && _();
}
catch (e) { }
